/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:29 GMT
 */
const tokens = {
    semantic: {
        color: {
            action: {
                primary: {
                    default: {
                        value: "#282e37",
                        type: "color",
                    },
                    hover: {
                        value: "#464e53",
                        type: "color",
                    },
                    active: {
                        value: "#121a26",
                        type: "color",
                    },
                    disabled: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    onPrimary: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                secondary: {
                    outline: {
                        value: "#282e37",
                        type: "color",
                    },
                    hoverFill: {
                        value: "#f3f3f3",
                        type: "color",
                    },
                    activeFill: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    disabledOutline: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    onSecondary: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                destructive: {
                    default: {
                        value: "#921a1d",
                        type: "color",
                    },
                    hover: {
                        value: "#d3222a",
                        type: "color",
                    },
                    active: {
                        value: "#5f091d",
                        type: "color",
                    },
                    disabled: {
                        value: "#921a1d80",
                        type: "color",
                    },
                    onDestructive: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                link: {
                    default: {
                        value: "#d3222a",
                        type: "color",
                    },
                    hover: {
                        value: "#ee312e",
                        type: "color",
                    },
                    active: {
                        value: "#921a1d",
                        type: "color",
                    },
                    disabled: {
                        value: "#ff686f",
                        type: "color",
                    },
                },
            },
            type: {
                default: {
                    value: "#282e37",
                    type: "color",
                },
                muted: {
                    value: "#6f7377",
                    type: "color",
                },
                disabled: {
                    value: "#a0a2a5",
                    type: "color",
                },
                inverse: {
                    value: "#ffffff",
                    type: "color",
                },
            },
            background: {
                base: {
                    value: "#ffffff",
                    type: "color",
                },
                container: {
                    value: "#f3f3f3",
                    type: "color",
                },
                navSelection: {
                    value: "#d3222a",
                    type: "color",
                },
            },
            accent: {
                red: {
                    background: {
                        value: "#ffedeb",
                        type: "color",
                    },
                    content: {
                        value: "#d3222a",
                        type: "color",
                    },
                },
                yellow: {
                    background: {
                        value: "#fff2aa",
                        type: "color",
                    },
                    content: {
                        value: "#fee400",
                        type: "color",
                    },
                },
                green: {
                    background: {
                        value: "#d2ff9c",
                        type: "color",
                    },
                    content: {
                        value: "#8ee400",
                        type: "color",
                    },
                },
                blue: {
                    background: {
                        value: "#d7f6ff",
                        type: "color",
                    },
                    content: {
                        value: "#1dd9f9",
                        type: "color",
                    },
                },
                purple: {
                    background: {
                        value: "#fdebff",
                        type: "color",
                    },
                    content: {
                        value: "#db8bff",
                        type: "color",
                    },
                },
            },
            ui: {
                focusRing: {
                    value: "#0b4cce",
                    type: "color",
                },
                divider: {
                    default: {
                        value: "#dadada",
                        type: "color",
                    },
                    secondary: {
                        value: "#a0a2a5",
                        type: "color",
                    },
                },
            },
            status: {
                success: {
                    default: {
                        value: "#8ee400",
                        type: "color",
                    },
                    background: {
                        value: "#d2ff9c",
                        type: "color",
                    },
                    text: {
                        value: "#3f6900",
                        type: "color",
                    },
                },
                warning: {
                    default: {
                        value: "#fee400",
                        type: "color",
                    },
                    background: {
                        value: "#fff2aa",
                        type: "color",
                    },
                    text: {
                        value: "#6a5f00",
                        type: "color",
                    },
                },
                notification: {
                    default: {
                        value: "#1dd9f9",
                        type: "color",
                    },
                    background: {
                        value: "#d7f6ff",
                        type: "color",
                    },
                    text: {
                        value: "#006879",
                        type: "color",
                    },
                },
                error: {
                    default: {
                        value: "#921a1d",
                        type: "color",
                    },
                    background: {
                        value: "#ffedeb",
                        type: "color",
                    },
                    text: {
                        value: "#921a1d",
                        type: "color",
                    },
                },
                new: {
                    default: {
                        value: "#d3222a",
                        type: "color",
                    },
                },
            },
            dataVisualization: {
                qualitative: {
                    blue: {
                        "01": {
                            value: "#00d3f3",
                            type: "color",
                        },
                        "02": {
                            value: "#00aaf3",
                            type: "color",
                        },
                        "03": {
                            value: "#0086fa",
                            type: "color",
                        },
                        "04": {
                            value: "#0b4cce",
                            type: "color",
                        },
                    },
                    purple: {
                        "04": {
                            value: "#4d1dd5",
                            type: "color",
                        },
                        "03": {
                            value: "#642fcf",
                            type: "color",
                        },
                        "02": {
                            value: "#8b4bfa",
                            type: "color",
                        },
                        "01": {
                            value: "#c247fa",
                            type: "color",
                        },
                    },
                    gray: {
                        "01": {
                            value: "#dadada",
                            type: "color",
                        },
                        "02": {
                            value: "#a0a2a5",
                            type: "color",
                        },
                        "03": {
                            value: "#6f7377",
                            type: "color",
                        },
                        "04": {
                            value: "#282e37",
                            type: "color",
                        },
                    },
                },
                sequential: {
                    positive: {
                        "01": {
                            value: "#9ef5ee",
                            type: "color",
                        },
                        "02": {
                            value: "#00e5d2",
                            type: "color",
                        },
                        "03": {
                            value: "#00ccbb",
                            type: "color",
                        },
                        "04": {
                            value: "#00a89a",
                            type: "color",
                        },
                        "05": {
                            value: "#04655d",
                            type: "color",
                        },
                    },
                    negative: {
                        "01": {
                            value: "#ffcce1",
                            type: "color",
                        },
                        "02": {
                            value: "#ff99c4",
                            type: "color",
                        },
                        "03": {
                            value: "#ff66a3",
                            type: "color",
                        },
                        "04": {
                            value: "#e6005c",
                            type: "color",
                        },
                        "05": {
                            value: "#a30041",
                            type: "color",
                        },
                    },
                    neutral: {
                        "01": {
                            value: "#fef9af",
                            type: "color",
                        },
                        "02": {
                            value: "#f4eb75",
                            type: "color",
                        },
                        "03": {
                            value: "#f5cc00",
                            type: "color",
                        },
                        "04": {
                            value: "#e5a500",
                            type: "color",
                        },
                        "05": {
                            value: "#9e6900",
                            type: "color",
                        },
                    },
                },
            },
        },
        shadow: {
            focus: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "0px",
                            blur: "0px",
                            spread: "calc(2px + 1px)",
                            color: "#0b4cce",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "0px",
                            blur: "0px",
                            spread: "1px",
                            color: "#ffffff",
                        },
                    ],
                    stringValue: "0px 0px 0px calc(2px + 1px) #0b4cce, 0px 0px 0px 1px #ffffff",
                },
                type: "shadow",
            },
            focusInset: {
                value: {
                    layers: [
                        {
                            inset: true,
                            offsetX: "0px",
                            offsetY: "0px",
                            blur: "0px",
                            spread: "2px",
                            color: "#0b4cce",
                        },
                        {
                            inset: true,
                            offsetX: "0px",
                            offsetY: "0px",
                            blur: "0px",
                            spread: "calc(2px + 1px)",
                            color: "#ffffff",
                        },
                    ],
                    stringValue: "inset 0px 0px 0px 2px #0b4cce, inset 0px 0px 0px calc(2px + 1px) #ffffff",
                },
                type: "shadow",
            },
            tooltip: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "6px",
                            blur: "9px",
                            spread: "0px",
                            color: "#161B2B24",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "0px",
                            blur: "1px",
                            spread: "0px",
                            color: "#00000038",
                        },
                    ],
                    stringValue: "0px 6px 9px 0px #161B2B24, 0px 0px 1px 0px #00000038",
                },
                type: "shadow",
            },
        },
        borderWidth: {
            thin: {
                value: "1px",
                type: "dimension",
            },
            thick: {
                value: "2px",
                type: "dimension",
            },
            focusWidth: {
                value: "2px",
                type: "dimension",
            },
            focusOffset: {
                value: "1px",
                type: "dimension",
            },
        },
        iconSize: {
            sm: {
                value: "16px",
                type: "dimension",
            },
            md: {
                value: "20px",
                type: "dimension",
            },
            lg: {
                value: "24px",
                type: "dimension",
            },
            xl: {
                value: "40px",
                type: "dimension",
            },
            "2xl": {
                value: "48px",
                type: "dimension",
            },
        },
        radius: {
            none: {
                value: "0px",
                type: "dimension",
            },
            sm: {
                value: "4px",
                type: "dimension",
            },
            md: {
                value: "8px",
                type: "dimension",
            },
            lg: {
                value: "12px",
                type: "dimension",
            },
            full: {
                value: "9999px",
                type: "dimension",
            },
        },
        layout: {
            mobile: {
                minWidth: {
                    value: "0px",
                    type: "dimension",
                },
                maxWidth: {
                    value: "600px",
                    type: "dimension",
                },
                columns: {
                    value: 4,
                    type: "number",
                },
                columnGap: {
                    value: "16px",
                    type: "dimension",
                },
                marginLeft: {
                    value: "16px",
                    type: "dimension",
                },
                marginRight: {
                    value: "16px",
                    type: "dimension",
                },
            },
            tablet: {
                minWidth: {
                    value: "601px",
                    type: "dimension",
                },
                maxWidth: {
                    value: "1279px",
                    type: "dimension",
                },
                columns: {
                    value: 8,
                    type: "number",
                },
                columnGap: {
                    value: "24px",
                    type: "dimension",
                },
                marginLeft: {
                    value: "24px",
                    type: "dimension",
                },
                marginRight: {
                    value: "24px",
                    type: "dimension",
                },
            },
            desktop: {
                minWidth: {
                    value: "1280px",
                    type: "dimension",
                },
                maxWidth: {
                    value: "1568px",
                    type: "dimension",
                },
                columns: {
                    value: 12,
                    type: "number",
                },
                columnGap: {
                    value: "24px",
                    type: "dimension",
                },
                marginLeft: {
                    value: "48px",
                    type: "dimension",
                },
                marginRight: {
                    value: "48px",
                    type: "dimension",
                },
            },
        },
        fontFamily: {
            body: {
                value: "Plus Jakarta Sans Variable",
            },
            title: {
                value: "Plus Jakarta Sans Variable",
            },
            label: {
                value: "Plus Jakarta Sans Variable",
            },
        },
        fontWeight: {
            regular: {
                value: 400,
                type: "number",
            },
            emphasis: {
                value: 600,
                type: "number",
            },
            link: {
                value: 800,
                type: "number",
            },
        },
        letterSpacing: {
            normal: {
                value: "0px",
                type: "dimension",
            },
            xs: {
                value: "0.2px",
                type: "dimension",
            },
            sm: {
                value: "0.3px",
                type: "dimension",
            },
            md: {
                value: "0.4px",
                type: "dimension",
            },
        },
        font: {
            text: {
                body: {
                    fontFamily: {
                        value: "Plus Jakarta Sans Variable",
                    },
                    fontSize: {
                        value: "1rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    letterSpacing: {
                        value: "0.2px",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.5rem",
                        type: "dimension",
                    },
                    textTransform: {
                        value: "none",
                        type: "string",
                    },
                    textDecoration: {
                        value: "none",
                        type: "string",
                    },
                },
                md: {
                    fontFamily: {
                        value: "Plus Jakarta Sans Variable",
                    },
                    fontSize: {
                        value: "0.875rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    letterSpacing: {
                        value: "0.2px",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.25rem",
                        type: "dimension",
                    },
                    textTransform: {
                        value: "none",
                        type: "string",
                    },
                    textDecoration: {
                        value: "none",
                        type: "string",
                    },
                },
                sm: {
                    fontFamily: {
                        value: "Plus Jakarta Sans Variable",
                    },
                    fontSize: {
                        value: "0.75rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    letterSpacing: {
                        value: "0.3px",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1rem",
                        type: "dimension",
                    },
                    textTransform: {
                        value: "none",
                        type: "string",
                    },
                    textDecoration: {
                        value: "none",
                        type: "string",
                    },
                },
            },
            title: {
                h1Billboard: {
                    fontFamily: {
                        value: "Plus Jakarta Sans Variable",
                    },
                    fontSize: {
                        value: "2rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    letterSpacing: {
                        value: "0px",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "2.5rem",
                        type: "dimension",
                    },
                    textTransform: {
                        value: "none",
                        type: "string",
                    },
                    textDecoration: {
                        value: "none",
                        type: "string",
                    },
                },
                h2Display: {
                    fontFamily: {
                        value: "Plus Jakarta Sans Variable",
                    },
                    fontSize: {
                        value: "1.625rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    letterSpacing: {
                        value: "0px",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "2.125rem",
                        type: "dimension",
                    },
                    textTransform: {
                        value: "none",
                        type: "string",
                    },
                    textDecoration: {
                        value: "none",
                        type: "string",
                    },
                },
                h3Lg: {
                    fontFamily: {
                        value: "Plus Jakarta Sans Variable",
                    },
                    fontSize: {
                        value: "1.375rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    letterSpacing: {
                        value: "0px",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.75rem",
                        type: "dimension",
                    },
                    textTransform: {
                        value: "none",
                        type: "string",
                    },
                    textDecoration: {
                        value: "none",
                        type: "string",
                    },
                },
                h4Md: {
                    fontFamily: {
                        value: "Plus Jakarta Sans Variable",
                    },
                    fontSize: {
                        value: "1.125rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    letterSpacing: {
                        value: "0.2px",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.75rem",
                        type: "dimension",
                    },
                    textTransform: {
                        value: "none",
                        type: "string",
                    },
                    textDecoration: {
                        value: "none",
                        type: "string",
                    },
                },
                h5Sm: {
                    fontFamily: {
                        value: "Plus Jakarta Sans Variable",
                    },
                    fontSize: {
                        value: "1rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    letterSpacing: {
                        value: "0.2px",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.5rem",
                        type: "dimension",
                    },
                    textTransform: {
                        value: "none",
                        type: "string",
                    },
                    textDecoration: {
                        value: "none",
                        type: "string",
                    },
                },
                h6Xs: {
                    fontFamily: {
                        value: "Plus Jakarta Sans Variable",
                    },
                    fontSize: {
                        value: "0.875rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    letterSpacing: {
                        value: "0.2px",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.25rem",
                        type: "dimension",
                    },
                    textTransform: {
                        value: "none",
                        type: "string",
                    },
                    textDecoration: {
                        value: "none",
                        type: "string",
                    },
                },
            },
            label: {
                lg: {
                    fontFamily: {
                        value: "Plus Jakarta Sans Variable",
                    },
                    fontSize: {
                        value: "0.875rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    letterSpacing: {
                        value: "0.2px",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.25rem",
                        type: "dimension",
                    },
                    textTransform: {
                        value: "none",
                        type: "string",
                    },
                    textDecoration: {
                        value: "none",
                        type: "string",
                    },
                },
                sm: {
                    fontFamily: {
                        value: "Plus Jakarta Sans Variable",
                    },
                    fontSize: {
                        value: "0.75rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    letterSpacing: {
                        value: "0.3px",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1rem",
                        type: "dimension",
                    },
                    textTransform: {
                        value: "none",
                        type: "string",
                    },
                    textDecoration: {
                        value: "none",
                        type: "string",
                    },
                },
                xs: {
                    fontFamily: {
                        value: "Plus Jakarta Sans Variable",
                    },
                    fontSize: {
                        value: "0.6875rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    letterSpacing: {
                        value: "0.4px",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1rem",
                        type: "dimension",
                    },
                    textTransform: {
                        value: "none",
                        type: "string",
                    },
                    textDecoration: {
                        value: "none",
                        type: "string",
                    },
                },
            },
        },
    },
};
export default tokens;
